import React, { useState } from "react";
import { TableContext } from "../../index";
import { debug } from "../../utils";
import { useHistory } from "react-router-dom";
import AnalysisTableHeader from "./AnalysisTableHeader";
import AnalysisTable from "./AnalysisTable";
import { AnalysisTableManagement } from "./AnalysisTableManagement";
import PaginationManager from "../../view/PaginationManager";
import * as ruleService from "../ruleService";
import { initShowChangesConfig } from "./HighlightManagement";

function AnalysisTableSection(props) {

    const history = useHistory();

    const initTableConfig = {
        selected: [],
        filtersLoading: true,
        isLoading: false,
        devices: [],
        showChanges: initShowChangesConfig
    }

    const [tableConfig, setTableConfig] = useState(initTableConfig);

    const changeTableConfig = (config) => {
        debug("Table config changed:", config);
        setTableConfig(config);
    }

    return (
        <TableContext.Provider value={{ config: tableConfig, setConfig: changeTableConfig }}>
            <div className="container-fluid" key={history.location}>
                <div className="row">
                    <div className="col-12">
                        <div className="card oct_analysis-card-v2">
                            <AnalysisTableManagement />
                            <AnalysisTableHeader />
                            <div className="card-body">
                                <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <AnalysisTable />
                                            <PaginationManager
                                                getPage={ruleService.validationResultListRealTimePageable}
                                                blocked={tableConfig.filtersLoading} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </TableContext.Provider>
    )
}

export default AnalysisTableSection;
